
import { Component, Vue } from "vue-property-decorator";
@Component
export default class LogoAppBar extends Vue {


  get logoWidth() {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return 150;
      case "sm":
        return 150;
      case "md":
        return 150;
      case "lg":
        return 200;
      case "xl":
        return 200;
    }
  }

}

